import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class PrivacyComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Política de Privacidad | Innovadoc IA');
    this.metaService.updateTag({ name: 'description', content: 'Lee la política de privacidad de Innovadoc IA. Descubre cómo protegemos tus datos y tu información personal.' });
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
  }
}
